//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export default definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e5effa',
      100: '#d2e1ef',
      200: '#a5c4e3',
      300: '#6090bf',
      400: '#3a6fa6',
      500: '#1c4b7b',
      600: '#19395a',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});
